<template>
    <div class="plan-detail-container">
        <lecture-component
            v-for="(lecture, index) in myCurrentSection.lecture"
            :key="lecture.id"
            :lecture="lecture"
            :valid="valid"
            @remove="remove"
            @edit="edit"
            :index="index"
        />
        <div class="content-course-box__additional" :class="{ active: isActive }">
            <button type="button" class="btn btn_plus" :class="{ active: isActive }" @click="isActive = !isActive">
                <v-icon src="plus" />
            </button>
            <div class="content-course-box__additional-list ">
                <ul class="list">
                    <li>
                        <button type="button" id="addLecture" class="btn btn_add" @click="addLecture">
                            <v-icon src="plus" /><span class="fs16">Лекция</span>
                        </button>
                    </li>
                    <!--                    <li>-->
                    <!--                        <button type="button" class="btn btn_add" @click="addLecture(lastTestId, 'test')">-->
                    <!--                            <v-icon src="plus" /><span class="fs16">Тест</span>-->
                    <!--                        </button>-->
                    <!--                    </li>-->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import LectureComponent from "../../old-files/PlanComponent/LectureComponent";
import { mapGetters, mapMutations, mapActions } from "vuex";
import EventBus from "../../../course-module/course-creating/services/EventBus";
import { api } from "../../old-files/services";

export default {
    name: "PlanDetail",
    components: { LectureComponent },

    props: {
        currentCourse: {
            type: Object,
            default: () => ({})
        }
    },

    data: () => ({
        isActive: false,
        currentSection: {
            lecture: []
        },
        valid: true
    }),

    computed: {
        ...mapGetters("teacher", ["myCurrentSection"])
    },

    watch: {
        currentCourse: {
            deep: true,
            handler() {
                // eslint-disable-next-line no-prototype-builtins
                this.getAllLectures({
                    section: this.currentCourse.sections.find(item => item.slug === this.$route.params.slug).id,
                    course: +this.$route.params.id
                }).then(() => {
                    this.$parent.$children.forEach(component => component.$forceUpdate());
                });
            }
        }
    },

    methods: {
        ...mapMutations("teacher", ["SET_NEW_LECTURE", "SET_CURRENT_SECTION"]),
        ...mapActions("teacher", ["getAllLectures"]),
        addLecture() {
            this.SET_NEW_LECTURE({
                section: this.currentCourse.sections.find(item => item.slug === this.$route.params.slug).id,
                course: +this.$route.params.id
            });
            this.$parent.$children.forEach(component => component.$forceUpdate());
        },
        remove(item) {
            if (item.slug) {
                api.deleteLecture(item.slug);
            }

            this.myCurrentSection.lecture.splice(item.index, 1);
            this.$parent.$children.forEach(component => component.$forceUpdate());
        },
        edit(item) {
            this.myCurrentSection.lecture[item.id] = item.lecture;
        }
    },

    beforeRouteLeave(to, from, next) {
        if (
            [
                this.myCurrentSection.lecture.every(item => !!item.name),
                this.myCurrentSection.lecture.every(item => !!item.description)
            ].every(item => item)
        ) {
            this.valid = true;
            EventBus.$emit("checkValid");
            next();
        } else {
            EventBus.$emit("checkValid");
            this.valid = false;
            next(false);
        }
    }

    // created() {
    //     this.SET_CURRENT_SECTION({
    //         section: this.currentCourse.sections.find(item => item.slug === this.$route.params.slug).id,
    //         course: +this.$route.params.id
    //     });
    // },
};
</script>

<style lang="scss" scoped>
.plan-detail-container {
    max-width: 640px;
}
</style>
